import React from 'react';

import TennisGameRate from '../rates/TennisGameRate.jsx';

const TennisGameOutcome = ({section, sportId, match, outcome, gridLocalization}) => {
    const outcomeRates = {};

    outcome.get('rates')
        .entrySeq()
        .sortBy((r) => r[0])
        .forEach((r) => {
            outcomeRates[r[0]] = r[1];
        });

    const matchObj = {
        homeTeam: match.get('firstTeam'),
        awayTeam: match.get('secondTeam')
    };

    const outcomeName = gridLocalization.getOutcomeName(sportId, outcome.toJS(), matchObj);

    const isBlocked = outcome.get('isBlocked');

    const conditionCls = 'out-cond' + (isBlocked ? ' closed' : '');

    const props = {
        section,
        gridLocalization
    };

    return (<span className="out">
                    <TennisGameRate key={outcomeRates[1]} id={outcomeRates[1]} {...props}/>
                    <span className={conditionCls}>{outcomeName}</span>
                    <TennisGameRate key={outcomeRates[2]} id={outcomeRates[2]} {...props}/>
                </span>
    );
};

TennisGameOutcome.propTypes = {
    section: React.PropTypes.string.isRequired,
    sportId: React.PropTypes.number.isRequired,
    match: React.PropTypes.object.isRequired,
    outcome: React.PropTypes.object.isRequired,
    gridLocalization: React.PropTypes.object.isRequired
};

export default TennisGameOutcome;



// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/components/outcomes/TennisGameOutcome.jsx